module.exports = __webpack_public_path__ + "static/media/ultrazvucni_denzitometar.e3c8dce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devices/ultrazvucni_denzitometar.jpg
// module id = 411
// module chunks = 0